module.exports = __webpack_public_path__ + "static/04-3-998f3602b5eb2004e335d632145d9896.jpg";